import { render } from "./text_step.vue?vue&type=template&id=00357200"
import script from "./text_step.vue?vue&type=script&lang=js"
export * from "./text_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/text_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00357200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00357200', __exports__)) {
    api.reload('00357200', __exports__)
  }
  
  module.hot.accept("./text_step.vue?vue&type=template&id=00357200", () => {
    api.rerender('00357200', render)
  })

}


export default __exports__